import logoSpott from '../../../../../assets/logo_spott.svg';
import './index.css';

export const Footer = () => {
  return (
    <div className='footer-container'>
      <span style={{ fontSize: '8pt' }}>Plugado na</span>
      <img src={logoSpott} alt={`${logoSpott}`} className='spott-icon' />
    </div>
  );
};
